import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Team from './components/Team';
import ReferenceProjects from './components/ReferenceProjects';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <Services />
      <About />
      <Team />
      <ReferenceProjects />
      <Gallery />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
